import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { Provider } from "react-redux";
import { store } from "./store";
import { useAppSelector } from "@/store/hooks.ts";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";
import AuthContext from "@hoc/AuthContext.tsx";

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    session: store.getState().auth,
  },
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  // eslint-disable-next-line
  interface Register {
    router: typeof router;
  }
}

// eslint-disable-next-line react-refresh/only-export-components
function App() {
  const session = useAppSelector((state) => state.auth);

  return (
    <AuthContext>
      <RouterProvider router={router} context={{ session }} />{" "}
    </AuthContext>
  );
}

// Render the app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  );
}
